import React from 'react';
import { Row } from 'react-bootstrap';
import { FormNumber, Fieldset, FormSelect } from '~/components/FormControl';
import { COMPARED_OPTIONS } from '~/config/constants';

function DiceValue() {
    return (
        <Fieldset className={'px-4'}>
            <Fieldset.Legend>DV:</Fieldset.Legend>
            <Row>
                <FormSelect
                    name="dvCompareOption"
                    options={COMPARED_OPTIONS || []}
                    sm={6}
                />
                <FormNumber
                    name="dvComparedValue"
                    sm={6}
                />
            </Row>
        </Fieldset>
    );
}

export default DiceValue;
